"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (action) {
    var searchBarEl = document.querySelector('.SearchBar');
    if (!searchBarEl || searchBarEl.classList.contains('is-hidden'))
        return;
    if (action === 'fadeOut') {
        searchBarEl.classList.add('lose-focus');
    }
    else {
        searchBarEl.classList.remove('lose-focus');
    }
});
